module.exports = __webpack_public_path__ + "img/cyber1.e4374dbd.jpg";